import React from 'react';
import { Reveal } from '../ui';

import screenMatch    from '../../assets/images/screen_match.jpg';
import screenDiscover from '../../assets/images/screen_discover.png';

export default function MatchMoment() {
  return (
    <section className="bg-black py-16 lg:py-[100px] px-[5%] relative overflow-hidden" id="connect-moment">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full"
             style={{ background: 'radial-gradient(circle, rgba(208,32,168,0.15) 0%, transparent 65%)' }} />
      </div>
      <div className="relative z-10 max-w-[1100px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
        <Reveal direction="left">
          <p className="text-xs font-medium tracking-[2.5px] uppercase text-pink-300 mb-4 block">The moment</p>
          <h2 className="text-[clamp(32px,4.5vw,56px)] font-bold tracking-[-2px] leading-none text-white mb-5">
            When it's<br /><span className="text-magenta">a connection ♥</span>
          </h2>
          <p className="text-base text-white/45 leading-relaxed font-light max-w-[420px]">
            When two people like each other, the magic happens. You're both notified, the chat opens, and a real conversation can begin. No awkwardness — just a genuine connection waiting to grow.
          </p>
        </Reveal>
        <Reveal direction="right">
          <div className="flex justify-center" style={{ perspective: '1000px' }}>
            <div className="w-[240px] h-[490px] bg-[#1a1a1a] rounded-[40px] p-3 overflow-hidden mx-auto"
                 style={{ boxShadow: '0 40px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.05)' }}>
              <div className="relative w-full h-full" style={{ transformStyle: 'preserve-3d', animation: 'autoFlip 7s ease-in-out 1.5s infinite' }}>
                <div className="absolute inset-0 rounded-[28px] overflow-hidden" style={{ backfaceVisibility: 'hidden' }}>
                  <img src={screenMatch} alt="Connection moment" className="w-full h-full object-cover block" />
                </div>
                <div className="absolute inset-0 rounded-[28px] overflow-hidden" style={{ backfaceVisibility: 'hidden', transform: 'rotateY(180deg)' }}>
                  <img src={screenDiscover} alt="Discover" className="w-full h-full object-cover block" />
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
